<template>
  <el-menu
      :default-active="$route.path"
      class="main-navigation"
      router
      :collapse="isCollapsed"
      :collapse-transition="false"
      :unique-opened="true"
      @select="$store.commit('clearBrItems')"
      v-if="userRole"
  >
    <template v-for="(item, index) in nav">
      <el-menu-item
          :key="index"
          v-if="!item.isSubmenu && item.main &&
          (item.meta.authorize.includes(userRole) ||
          !item.meta.authorize.length)"
          :index="`/app/${item.path}`"
      >
        <img class="menu-item__img" :src="item.imgUrl" :alt="item.title"/>
        <span class="title">{{ item.title }}</span>
      </el-menu-item>

      <el-sub-menu
          class="custom-submenu"
          :key="index"
          v-if="item.isSubmenu &&
          (item.meta.authorize.includes(userRole) ||
          !item.meta.authorize.length)"
          :index="index.toString()"
      >
        <template #title>
          <img class="menu-item__img" :src="item.imgUrl" :alt="item.title"/>
          <span>{{ item.title }}</span>
        </template>

        <template v-if="item.children" v-for="menu in item.children" :key="menu.title">
          <el-menu-item
              v-if="menu.main && !menu.children &&
              (menu.meta.authorize.includes(userRole) ||
              !menu.meta.authorize.length)"
              :key="menu.path"
              :index="`/app/${menu.path}`"
          >
            <img class="menu-item__img" :src="menu.imgUrl" :alt="menu.title"/>
            <span>{{ menu.title }}</span>
          </el-menu-item>

          <!-- Added sub-sub-menu -->
          <el-sub-menu
              class="custom-submenu"
              :key="menu.path"
              v-if="menu.isSubmenu && menu.children &&
              (menu.meta.authorize.includes(userRole) ||
              !menu.meta.authorize.length)"
              :index="menu.path?`/app/${menu.path}`: menu.title"
          >
            <template #title>
              <img class="menu-item__img" :src="menu.imgUrl" :alt="menu.title"/>
              <span>{{ menu.title }}</span>
            </template>

            <template v-for="submenu in menu.children" :key="submenu.title">
              <el-menu-item
                  v-if="submenu.main &&
                  (submenu.meta.authorize.includes(userRole) ||
                  !submenu.meta.authorize.length)"
                  :key="submenu.path"
                  :index="submenu.path ? `/app/${submenu.path}` : ''"
              >
                <img class="menu-item__img" :src="submenu.imgUrl" :alt="submenu.title"/>
                <span>{{ submenu.title }}</span>
              </el-menu-item>
            </template>

          </el-sub-menu>
          <!-- End of sub-sub-menu -->

        </template>
      </el-sub-menu>
    </template>
  </el-menu>
</template>

<script>
import Navigations from "../router/navigation";

export default {
  name: "MainNavigation",
  computed: {
    userRole() {
      return this.$store.state.role;
    },
    nav() {
      return Navigations.filter(item => item.meta.authorize.includes(this.userRole));
    },
    isCollapsed() {
      return this.$store.state.collapsed
    }
  }
};
</script>


<style scoped>
.custom-submenu-open {
  display: block !important;
}

.main-navigation {
  max-height: calc(100vh - 120px);
  padding-bottom: 40px;
  overflow: auto;
  border: none;
}

.main-navigation::-webkit-scrollbar {
  display: none;
}


.el-menu-item {
  height: 55px;
  font-weight: 600;
  transition: all 0.1s;
  overflow: hidden;
  font-size: 15px;
  border-radius: 8px;
  margin: 0 5px 5px;
  color: #007791;
}

:deep(.el-sub-menu__title ) {
  color: #007791;
  font-size: 15px;
  font-weight: 600;
}

.el-menu-item.is-active {
  font-size: 16px;
  background-color: rgba(203, 224, 227, 0.66);
}


.el-sub-menu /deep/ {
  margin: 0 5px;
}

.el-sub-menu /deep/ > .el-menu {
  border-radius: 5px;
  padding: 5px 0;
}

.el-sub-menu /deep/ .el-sub-menu__title {
  border-radius: 5px;
  margin-bottom: 5px;
}

.menu-item__img {
  margin-right: 15px;
  margin-bottom: 4px;
}

ul li:before {
  content: none;
}
</style>
